import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import Icon from '#components/icon.jsx';

export const DragHandleContext = React.createContext();
DragHandleContext.displayName = 'DragHandleContext';

export function makeSortable(Item) {
    return function Sortable(props) {
        const { id, index, ...rest } = props;
        const { attributes, listeners, setNodeRef, setActivatorNodeRef, isDragging, transform, transition } =
            useSortable({
                id: id ?? index
            });

        const style = {
            transform: CSS.Transform.toString(transform),
            opacity: isDragging ? 0.4 : 1,
            transition
        };

        const dragHandleProps = { ref: setActivatorNodeRef, ...listeners, ...attributes };

        return (
            <DragHandleContext.Provider value={dragHandleProps}>
                <Item ref={setNodeRef} isDragging={true} style={style} {...rest} />
            </DragHandleContext.Provider>
        );
    };
}

function _DragHandle(props, ref) {
    const { children, className, ...rest } = props;
    return (
        <button ref={ref} className={className || 'w-6 h-6 flex justify-center items-center'} {...rest}>
            <Icon id="drag-dots" />
            {children}
        </button>
    );
}

export const DragHandle = React.forwardRef(_DragHandle);
